function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _createForOfIteratorHelper(r, e) { var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (!t) { if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) { t && (r = t); var _n = 0, F = function F() {}; return { s: F, n: function n() { return _n >= r.length ? { done: !0 } : { done: !1, value: r[_n++] }; }, e: function e(r) { throw r; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var o, a = !0, u = !1; return { s: function s() { t = t.call(r); }, n: function n() { var r = t.next(); return a = r.done, r; }, e: function e(r) { u = !0, o = r; }, f: function f() { try { a || null == t["return"] || t["return"](); } finally { if (u) throw o; } } }; }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _callSuper(t, o, e) { return o = _getPrototypeOf(o), _possibleConstructorReturn(t, _isNativeReflectConstruct() ? Reflect.construct(o, e || [], _getPrototypeOf(t).constructor) : o.apply(t, e)); }
function _possibleConstructorReturn(t, e) { if (e && ("object" == _typeof(e) || "function" == typeof e)) return e; if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined"); return _assertThisInitialized(t); }
function _assertThisInitialized(e) { if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); return e; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _getPrototypeOf(t) { return _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) { return t.__proto__ || Object.getPrototypeOf(t); }, _getPrototypeOf(t); }
function _inherits(t, e) { if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function"); t.prototype = Object.create(e && e.prototype, { constructor: { value: t, writable: !0, configurable: !0 } }), Object.defineProperty(t, "prototype", { writable: !1 }), e && _setPrototypeOf(t, e); }
function _setPrototypeOf(t, e) { return _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) { return t.__proto__ = e, t; }, _setPrototypeOf(t, e); }
module.exports = function (purchaseService, priceTaxFeeAdjusterBase, promoService, clone) {
  var priceTaxFeeAdjuster = /*#__PURE__*/function (_priceTaxFeeAdjusterB) {
    function priceTaxFeeAdjuster(supplementalData) {
      var _this;
      _classCallCheck(this, priceTaxFeeAdjuster);
      _this = _callSuper(this, priceTaxFeeAdjuster, [supplementalData]);
      _this.name = "fee";
      _this.id = priceTaxFeeAdjuster.nextId;
      priceTaxFeeAdjuster.nextId++;
      _this.supplementalData = null;
      _this.priority = priceTaxFeeAdjuster.taxPriority - 1000; // we hope this will keep it first...
      _this.roundByGroup = "fee";
      _this.groupIdPath = "extra.feeRule.name";
      return _this;
    }
    _inherits(priceTaxFeeAdjuster, _priceTaxFeeAdjusterB);
    return _createClass(priceTaxFeeAdjuster, [{
      key: "setFeeincFinal",
      value: function setFeeincFinal(p, index, clonedList) {
        var incExc = {
          inc: 0,
          exc: 0
        };

        /*****************************************************************************
         * any promo can affect fee inclusivity status with the following rules
         * - if all "feeinc"s are "false", product "feeinc" is set to "false"
         * - otherwise, if one promo's "feeinc" is "true" - then the product "feeinc" is true
         * furthermore, once a promo is activated on an item, any item with the same upc gets the promo fee-inclusivity rule applied
         ******************************************************************************/
        if (p.priceTaxFeeAdjustments && p.priceTaxFeeAdjustments.length) {
          var promos = p.priceTaxFeeAdjustments.filter(function (a) {
            return a.name === "promo";
          });
          if (promos.length) {
            var allAreFeeExclusive = promos.every(function (a) {
              return !a.extra.promo.pricing.inclfees;
            });
            // as long as not all are fee-exclusive the final status will be fee-inclusive
            var thisFeeincFinal = !allAreFeeExclusive;
            // get all "winning" promos - the ones that were part of deciding who shall set the products inclusivity status
            // (this just excludes fee-exclusive promos when there were one or more other fee-inclusive promos)
            var feeincPromos = promos.filter(function (a) {
              return a.extra.promo.pricing.inclfees == thisFeeincFinal;
            });
            var affectedUpcsArrayList = feeincPromos.map(function (a) {
              return a.extra.promo.upcs;
            });
            var affectedUpcs = [].concat.apply([], affectedUpcsArrayList);

            // if the offer made it to this product, we need to set the previous one to have fee-inc/exc on the totality of its quantity
            for (var c = 0; c < index; ++c) {
              if (affectedUpcs.includes(clonedList[c].upc)) {
                clonedList[c].feeincFinal = thisFeeincFinal ? {
                  inc: clonedList[c].effectiveQuantity,
                  exc: 0
                } : {
                  inc: 0,
                  exc: clonedList[c].effectiveQuantity
                };
              }
            }

            // we shall just take the first promo's affected amount and ignore more complex scenarios where multiple promos affect the inclusivity progressively
            var arbitraryPromoAffectedAmount = promos[0].extra.qtyAffected ? promos[0].extra.qtyAffected : p.effectiveQuantity;
            incExc[thisFeeincFinal ? "inc" : "exc"] = arbitraryPromoAffectedAmount;
          }
        }
        p.feeincFinal = p.pricing.inclfees ? {
          inc: p.effectiveQuantity - incExc.exc,
          exc: incExc.exc
        } : {
          inc: incExc.inc,
          exc: p.effectiveQuantity - incExc.inc
        };
      }
    }, {
      key: "calculate",
      value: function calculate(productlist) {
        var _this2 = this;
        var realproductlist = productlist.filter(function (a) {
          return typeof a.upc !== "undefined" && !a.isFree;
        });

        // splice out all priceTaxFeeAdjustments of the type that this function will create before recalc otherwise we'll get two with the same name/id
        var _iterator = _createForOfIteratorHelper(realproductlist),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _p = _step.value;
            if (_p.priceTaxFeeAdjustments && _p.priceTaxFeeAdjustments.length) {
              _p.priceTaxFeeAdjustments = _p.priceTaxFeeAdjustments.filter(function (a) {
                return !(a.name === _this2.name && a.id === _this2.id);
              });
            }
          }

          /************************************************************
           * working out if product is 'fee/tax-inclusive/exclusive' is non-trivial
           * it might just be the p.pricing.inclfees flag set to true
           * or it may be set by a promo, if the promo gets applied and contains the "inclfees: true" setting
           * except that at the point we are calculating fees we have not yet calculated which of the promos get activated on which product
           * and we can't apply post-tax promos before taxes and fees because they will affect the tax and fee calculations since they lower the net product prices on which the taxes and fees may be based
           * so we have to calculate them on a dummy product list - "clonedProductListWithPromosCalculated"
           ************************************************************/
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
        var clonedProductListWithPromosCalculated = clone(realproductlist);
        var _priceTaxFeeAdjuster = new promoService.priceTaxFeeAdjuster(clonedProductListWithPromosCalculated);
        var promoPriceTaxFeeAdjusters = purchaseService.priceTaxFeeAdjusters.filter(function (a) {
          return a.name === "promo";
        });
        if (!promoPriceTaxFeeAdjusters.length) {
          console.warn("Warning! promoPriceTaxFeeAdjusters has length 0!");
        }
        promoPriceTaxFeeAdjusters.forEach(function (a) {
          return a.calculate(clonedProductListWithPromosCalculated);
        });
        clonedProductListWithPromosCalculated.forEach(function (p, index, clonedList) {
          return _this2.setFeeincFinal(p, index, clonedList);
        });
        for (var productIndex = 0, p; p = realproductlist[productIndex]; ++productIndex) {
          var priceTaxFeeAdjustments = [];
          var feeRules = p.revauths.filter(function (a) {
            return a.type === "Fee";
          });
          if (!feeRules.length) {
            continue;
          }

          // first calculate taxes on skuprice
          // some optimization: we only need to calculate lineItemPrice if there are any rate_decibps rules
          if (feeRules.find(function (a) {
            return a.rate_decibps;
          })) {
            var lineItemInitialUnitPrice = p.skuprice / p.skuqty;
            var precedingPriceUnitAdjustments = p.priceTaxFeeAdjustments ? p.priceTaxFeeAdjustments.filter(function (a) {
              return a.priority < _this2.priority;
            }).reduce(function (total, a) {
              return total + a.price;
            }, 0) / p.effectiveQuantity : 0;
            var lineItemUnitPrice = lineItemInitialUnitPrice + precedingPriceUnitAdjustments;
          }
          var _iterator2 = _createForOfIteratorHelper(feeRules),
            _step2;
          try {
            for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
              var feeRule = _step2.value;
              var priceAdjustment = 0; // if the price includes fee then the real price is skuprice minus fee

              if (feeRule.per_item_cents) {
                // if it is a multi-item then fee applies per unit and not per purchase item
                var incFeeAmount = clonedProductListWithPromosCalculated[productIndex].feeincFinal.inc * feeRule.per_item_cents * (p.pricing.fee_multiplier || 1) / (p.byweight ? p.effectiveQuantity : 1);
                var excFeeAmount = clonedProductListWithPromosCalculated[productIndex].feeincFinal.exc * feeRule.per_item_cents * (p.pricing.fee_multiplier || 1) / (p.byweight ? p.effectiveQuantity : 1);
              } else {
                var feeFraction = feeRule.rate_decibps / 100000;

                // if the price includes fees then the real fraction is the quotient of 1 + the exclusive fraction
                var incFeeFraction = feeFraction / (1 + feeFraction);
                var excFeeFraction = feeFraction;
                var incFeeAmount = clonedProductListWithPromosCalculated[productIndex].feeincFinal.inc * lineItemUnitPrice * incFeeFraction;
                var excFeeAmount = clonedProductListWithPromosCalculated[productIndex].feeincFinal.exc * lineItemUnitPrice * excFeeFraction;
              }
              if (incFeeAmount) {
                priceTaxFeeAdjustments.push({
                  name: this.name,
                  id: this.id,
                  priority: this.priority,
                  price: -incFeeAmount,
                  tax: 0,
                  fee: incFeeAmount,
                  extra: {
                    feeRule: feeRule,
                    fee_multiplier: p.pricing.fee_multiplier
                  }
                });
              }
              if (excFeeAmount) {
                priceTaxFeeAdjustments.push({
                  name: this.name,
                  id: this.id,
                  priority: this.priority,
                  price: 0,
                  tax: 0,
                  fee: excFeeAmount,
                  extra: {
                    feeRule: feeRule,
                    fee_multiplier: p.pricing.fee_multiplier
                  }
                });
              }
            }
          } catch (err) {
            _iterator2.e(err);
          } finally {
            _iterator2.f();
          }
          if (priceTaxFeeAdjustments.length) {
            p.priceTaxFeeAdjustments = p.priceTaxFeeAdjustments || [];
            Array.prototype.push.apply(p.priceTaxFeeAdjustments, priceTaxFeeAdjustments); // merge new priceTaxFeeAdjustments array into existing p.priceTaxFeeAdjustments array
            var priceTaxFeeAdjustments = [];
          }
        }
      }
    }]);
  }(priceTaxFeeAdjusterBase);
  priceTaxFeeAdjuster.nextId = 0;
  priceTaxFeeAdjuster.taxPriority = 0; // so positive priorities are post-tax adjusters and negative values are pre-tax

  return {
    priceTaxFeeAdjuster: priceTaxFeeAdjuster
  };
}(require('../../module/purchase/service.js'), require("../base.js"), require("./promo.js"), require("clone"));